import React from 'react';
import { useNavigate } from 'react-router-dom';

const UploadContent = ({ onNavigate }) => {
  const navigate = useNavigate();
  
  const handleGoBack = () => {
    navigate('/system-files');
    if (onNavigate) {
      onNavigate('core-data');
    }
  };
  
  return (
    <div>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '1rem' 
      }}>
        {/* Step 1 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            1
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Upload Files
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Drag and drop Excel files in the main content area or click to browse
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            2
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Processing & Validation
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              System analyzes file structure and extracts data with real-time progress
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'flex-start', 
          gap: '1rem',
          background: '#3a3a3a', 
          borderRadius: '12px', 
          padding: '1.25rem',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)',
            color: 'white',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            3
          </div>
          <div>
            <div style={{ 
              color: '#e0e0e0', 
              fontWeight: '600', 
              marginBottom: '0.5rem',
              fontSize: '15px'
            }}>
              Review & Manage
            </div>
            <div style={{ 
              color: '#a0a0a0', 
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Use History tab to track uploads and Summary tab to view imported records
            </div>
          </div>
        </div>
      </div>
      
      <div style={{ 
        background: 'rgba(255, 255, 255, 0.05)', 
        borderRadius: '8px', 
        padding: '1rem',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        marginTop: '1.5rem'
      }}>
        <div style={{ fontSize: '0.875rem', color: '#a0a0a0', textAlign: 'center' }}>
          💡 Use the upload area in the main content area to add your Excel files
        </div>
      </div>
      
      {/* Go Back Button */}
      <div style={{ 
        marginTop: '1.5rem',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <button
          onClick={handleGoBack}
          style={{
            background: '#4a4a4a',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '8px',
            padding: '0.75rem 1.5rem',
            fontSize: '0.875rem',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#5a5a5a';
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#4a4a4a';
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
          }}
        >
          ← Back to Core Data
        </button>
      </div>
    </div>
  );
};

export default UploadContent;
